import { render, staticRenderFns } from "./allProducts.vue?vue&type=template&id=c0e53814&scoped=true"
import script from "./allProducts.vue?vue&type=script&lang=js"
export * from "./allProducts.vue?vue&type=script&lang=js"
import style0 from "./allProducts.vue?vue&type=style&index=0&id=c0e53814&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e53814",
  null
  
)

export default component.exports